import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username.trim() || !password) {
      setError("Enter username and password");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          username: username.trim(),
          password,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        sessionStorage.setItem("isAuthenticated", "true");
        setSuccess(true);
      } else {
        setError(data?.error || data?.message || "Invalid username or password");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Network error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    navigate("/dashboard");
  };

  return (
  <div className="login-wrapper">
    {/* LOGIN CARD */}
    <form
      onSubmit={handleLogin}
      className={`login-card transition-all duration-300 ${
        success ? "opacity-40 pointer-events-none" : "opacity-100"
      }`}
    >
      <h2 className="text-2xl font-bold mb-4 text-center text-white">
        Dashboard Access
      </h2>

      {error && (
        <p className="text-red-400 mb-3 text-center text-sm">
          {error}
        </p>
      )}

      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="border p-2 mb-4 w-full rounded"
        required
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="border p-2 mb-5 w-full rounded"
        required
      />

      {/* BUTTON GROUP */}
      <div className="flex flex-col items-center gap-3">
        {/* SIGN IN BUTTON */}
        <button
          type="submit"
          disabled={loading}
          className="btn-kyc btn-black min-w-[200px]"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        {/* CLEAR BUTTON */}
        <button
          type="button"
          className="btn-kyc btn-white min-w-[200px]"
          onClick={() => {
            setUsername("");
            setPassword("");
            setError("");
          }}
        >
          Clear
        </button>
      </div>
    </form>

    {/* SUCCESS POPUP */}
    {success && (
      <div className="absolute z-20 bg-white p-6 rounded shadow-lg text-center w-80">
        <p className="text-green-600 font-semibold text-lg mb-4">
          ✅ Successfully logged in!
        </p>
        <button
          onClick={handleOk}
          className="btn-kyc btn-black"
        >
          OK
        </button>
      </div>
    )}
  </div>
);
};

export default Login;
